import Features from "@/components/Features";
import DOMPurify from "dompurify";
import {parseMergeTags} from "@/helpers";
import {useAppState} from "@/store";

export default function Confirmation() {

    const {state} = useAppState()

    const content = window.ein?.content?.step_6_1 || {}

    const {title, secondary_title, tertiary_title, text, button_url, button_text_desktop, button_text_mobile} = content

    return (
        <div className={"grid grid-cols-4 lg:grid-cols-12 gap-x-[20px] lg:gap-x-[32px] gap-y-[40px]"}>
            <div className="col-span-4 lg:col-span-4 flex items-center justify-center">
                <img src={window.ein.plugin_url + 'images/einstein-full.svg'} className={"w-full max-w-[215px] lg:max-w-full"} alt="Einstein Illustration"/>
            </div>
            <div className="col-span-4 lg:col-span-8 flex flex-col justify-center items-start">
                {title && (
                    <div className="heading-h1 mb-[8px]">
                        {parseMergeTags(title, state)}
                    </div>
                )}
                {secondary_title && (
                    <div
                        className={"mb-[32px] text-big text-steel-grey/80 [&>:last-child]:mb-0"}
                        dangerouslySetInnerHTML={{'__html': DOMPurify.sanitize(parseMergeTags(secondary_title, state))}}
                    />
                )}
                {tertiary_title && (
                    <div className="heading-h3 mb-[16px]">
                        {parseMergeTags(tertiary_title, state)}
                    </div>
                )}
                <div
                    className={"mb-[32px] [&>:last-child]:mb-0"}
                    dangerouslySetInnerHTML={{'__html': DOMPurify.sanitize(parseMergeTags(text, state))}}
                />
                {button_url && button_text_desktop && (
                    <a href={button_url} className="ein-btn hidden lg:!inline-flex">{button_text_desktop}</a>
                )}
                {button_url && button_text_mobile && (
                    <a href={button_url} className="ein-btn !inline-flex lg:!hidden">{button_text_mobile}</a>
                )}
            </div>
            <div className="col-span-4 lg:col-span-12">
                <Features/>
            </div>
        </div>
    )
}
